module.exports = __webpack_public_path__ + "static/img/cont58_05.d93bf53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont58_05.jpg
// module id = cwaP
// module chunks = 0